import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output, Injector, ViewChild, ChangeDetectorRef
} from '@angular/core';

import { AppComponentBase } from '@shared/common/app-component-base';
import { CustomerNewsInfosServiceProxy, GetAiNewsInfoDto } from '@shared/service-proxies/service-proxies';
import { IAjaxResponse, TokenService } from '@node_modules/abp-ng2-module';
import { AppConsts } from '@shared/AppConsts';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular/ckeditor.component';
import { CKFinderObj } from 'assets/CKFinderScripts/ckfinder.js'
import { visualDomDiff } from 'visual-dom-diff'
// import Editor from 'ckeditor5-custom-build/build/ckeditor';
import {
  ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo,
  CKFinder,
  CKFinderUploadAdapter,
  Alignment,
  AutoImage,
  Autoformat,
  AutoLink,
  BlockQuote,
  CloudServices,
  Code,
  CodeBlock,
  FindAndReplace,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  Highlight,
  HorizontalLine,
  HtmlComment,
  HtmlEmbed,
  Image,
  ImageResizeEditing,
  ImageResizeHandles,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Link,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  MediaEmbedToolbar,
  PasteFromOffice,
  SourceEditing,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  StandardEditingMode,
  Strikethrough,
  Style,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  Underline,
  RemoveFormat
} from 'ckeditor5';
import { UploadFileAdapter } from './uploadFileAdapter';
import SourceEditingEnhanced from './source-editing-enhanced.plugin';
import AiSourceEditing from './ai-source-editing-enhanced.plugin';
import { AiPromptType } from '@shared/service-proxies/service-proxies';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
@Component({
  selector: 'ai-editor-modal',
  templateUrl: './ai-editor-modal.component.html',
  styleUrls: ['./ai-editor-model.component.css']
})
export class AiEditorModalComponent implements OnDestroy {
  @Input() initialHtml = '';
  @Output() save = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();
  public Editor = ClassicEditor;
  @ViewChild('leftCk', { static: false }) leftCk?: CKEditorComponent;
  @ViewChild('rightCk', { static: false }) rightCk?: CKEditorComponent;

  constructor(private injector: Injector,
    private _newsInfosServiceProxy: CustomerNewsInfosServiceProxy,
    private cdr: ChangeDetectorRef,
    private _tokenService: TokenService) {
  }
  // Editor build and config come from window (exposed by your HtmlEditorComponent)

  public config = {
    plugins: [CKFinder,
      CKFinderUploadAdapter,
      Alignment,
      AutoImage,
      Autoformat,
      AutoLink,
      BlockQuote,
      Bold,
      CloudServices,
      Code,
      CodeBlock,
      Essentials,
      FindAndReplace,
      FontBackgroundColor,
      FontColor,
      FontFamily,
      FontSize,
      GeneralHtmlSupport,
      Heading,
      Highlight,
      HorizontalLine,
      HtmlComment,
      HtmlEmbed,
      Image,
      ImageResizeEditing,
      ImageResizeHandles,
      ImageCaption,
      ImageInsert,
      ImageResize,
      ImageStyle,
      ImageToolbar,
      ImageUpload,
      Indent,
      IndentBlock,
      Italic,
      Link,
      LinkImage,
      List,
      ListProperties,
      MediaEmbed,
      MediaEmbedToolbar,
      Paragraph,
      PasteFromOffice,
      SpecialCharacters,
      SpecialCharactersArrows,
      SpecialCharactersCurrency,
      SpecialCharactersEssentials,
      SpecialCharactersLatin,
      SpecialCharactersMathematical,
      SpecialCharactersText,
      StandardEditingMode,
      Strikethrough,
      Style,
      Table,
      TableCaption,
      TableCellProperties,
      TableColumnResize,
      TableProperties,
      TableToolbar,
      TextTransformation,
      Underline,
      RemoveFormat,
      SourceEditingEnhanced
    ],
    toolbar: [
      'sourceEditingEnhanced',
      'removeFormat',
      'fontFamily',
      'heading',
      'ckfinder',
      '|',
      'highlight',
      'fontSize',
      'fontColor',
      'bold',
      'italic',
      'underline',
      'link',
      'bulletedList',
      'numberedList',
      '|',
      'alignment',
      'outdent',
      'indent',
      '|',
      'blockQuote',
      'insertTable',
      'mediaEmbed',
      'undo',
      'redo',
      'specialCharacters',
      'htmlEmbed',
      'horizontalLine',
      'fontBackgroundColor',
      'findAndReplace',
      'codeBlock',
      'code'],
    image: {
      resizeOptions: [
        {
          name: 'resizeImage:original',
          value: null,
          label: 'Original'
        },
        {
          name: 'resizeImage:custom',
          label: 'Custom',
          value: 'custom'
        },
        {
          name: 'resizeImage:40',
          value: '40',
          label: '40%'
        },
        {
          name: 'resizeImage:50',
          value: '50',
          label: '50%'
        },
        {
          name: 'resizeImage:60',
          value: '60',
          label: '60%'
        },
        {
          name: 'resizeImage:70',
          value: '70',
          label: '70%'
        },
        {
          name: 'resizeImage:80',
          value: '80',
          label: '80%'
        },
        {
          name: 'resizeImage:90',
          value: '90',
          label: '90%'
        },
        {
          name: 'resizeImage:100',
          value: '100',
          label: '100%'
        }
      ],
      toolbar: ['toggleImageCaption', 'imageTextAlternative', '|',
        {
          // Grouping the buttons for the icon-like image styling
          // into one dropdown.
          name: 'imageStyle:pictures',
          title: 'Style',
          items: [
            'imageStyle:alignLeft',
            'imageStyle:alignRight',
            'imageStyle:alignBlockLeft',
            'imageStyle:alignBlockRight',
            'imageStyle:alignCenter',
          ],
          defaultItem: 'imageStyle:alignCenter'
        },
        '|',
        'resizeImage', 'linkImage'],
      insert: {
        // If this setting is omitted, the editor defaults to 'block'.
        // See explanation below.
        type: 'block'
      }
    },
    fontFamily: {
      options: [
        'default',
        '"Mulish", sans-serif',
      ]
    },
    mediaEmbed: {
      previewsInData: true,
      extraProviders: [
        {
          name: 'localVideoFile',
          url: /.(flv|mp4|avi)/,
          // html: (match) => `The HTML representing the media with ID=${ console.log(match)}.`,
          html: match =>
            '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
            `<video style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;"  controls="" autoplay="" name="media"><source src="${match.input}" type="video/mp4"></video>` +
            '</div>'
        },
        {
          name: 'localPdfFile',
          url: /.(pdf)/,
          // html: (match) => `The HTML representing the media with ID=${ console.log(match)}.`,
          html: match =>
            `<iframe src="${match.input}" width="100%" height="800px" frameborder="0" > </iframe>`
        }
      ]
    },
    licenseKey: 'EUNUV69XE5M1WFV7K3XY4BBPVGFLQ',
    mention: {
      // Mention configuration
    },
    table: {
      defaultHeadings: { rows: 1 },
      contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties', 'tableProperties', 'toggleTableCaption'],
      tableProperties: {
        defaultProperties: {
          borderStyle: 'solid',
          borderColor: 'hsl(0, 0%, 90%)',
          borderWidth: '3px',
          alignment: 'left'
        }
      },
      tableCellProperties: {
        defaultProperties: {
          borderStyle: 'solid',
          horizontalAlignment: 'left',
          verticalAlignment: 'middle',
          padding: '5px'
        }
      }
    },
    htmlSupport: {
      allow: [
        {
          name: /^(div|section|article|.*)$/,
          attributes: true,
          classes: true,
          styles: true
        }
      ]
    },
    ckfinder: {
      // Upload the images to the server using the CKFinder QuickUpload command.
      uploadUrl: '',
      options: {
      }
    }

  };


  get leftEditorInstance(): any | null {
    return this.leftCk && (this.leftCk as any).editorInstance ? (this.leftCk as any).editorInstance : null;
  }
  get rightEditorInstance(): any | null {
    return this.rightCk && (this.rightCk as any).editorInstance ? (this.rightCk as any).editorInstance : null;
  }

  public loading = false;
  public loadingStatus = '';
  private isSyncing = false;
  public live = true;

  // data used for binding
  leftData = '';
  rightData = '';

  ngOnInit() {
    var token = this._tokenService.getToken();
    var baseCkfinderUrl = AppConsts.ckfinderBaseUrl;
    this.config.ckfinder.uploadUrl = baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Images&responseType=json&token=' + token;
    window["CKFinder"].config({
      language: 'vi',
      connectorInfo: "token=" + token,
      connectorPath: baseCkfinderUrl + '/ckfinder/connector',
      filebrowserBrowseUrl: baseCkfinderUrl + '/ckfinder/ckfinder.html',
      filebrowserImageBrowseUrl: baseCkfinderUrl + '/ckfinder/ckfinder.html?type=Images',
      filebrowserFlashBrowseUrl: baseCkfinderUrl + '/ckfinder/ckfinder.html?type=Flash',
      filebrowserUploadUrl: baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Files',
      filebrowserImageUploadUrl: baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Images',
      filebrowserFlashUploadUrl: baseCkfinderUrl + '/ckfinder/connector?command=QuickUpload&type=Flash'
    });

    // original data
    this.leftData = this.initialHtml || '';




  }


  applyToPreview(aiPromptType: AiPromptType) {
    // ai + compare data

    try {
      this.startLoading('AI đang xử lý nội dung');

      var data = new GetAiNewsInfoDto();
      data.aiPromptType = aiPromptType;
      data.newsDetail = this.leftEditorInstance.getData();

      const parser = new DOMParser();
      const docA = parser.parseFromString(data.newsDetail, "text/html").body;


      this._newsInfosServiceProxy.aiNewsInfo(data).subscribe(result => {
        this.startLoading('AI Đang so sánh những thay đổi');
        var aiContent = result || '';
        const docB = parser.parseFromString(aiContent, "text/html").body;
        var diffNode = null;
        // var visualDomDiff = (window as any).visualDomDiff;
        try {
          diffNode = visualDomDiff(docA, docB);
        } catch (e) {

          console.log(e);
        }
        if (diffNode) {
          try {
            const serializer = new XMLSerializer();
            this.rightData = serializer.serializeToString(diffNode);
          } catch {
            this.rightData = (diffNode as any).outerHTML || (diffNode as any).innerHTML || String(diffNode);
          }
        } else {
          this.rightData = this.initialHtml || '';
        }
        this.stopLoading();
      });

    } catch {
      this.stopLoading();
    }

  }

  formatRight() {
    // basic fallback formatting — you may replace with a proper beautifier plugin
    if (!this.rightEditorInstance) return;
    const raw = this.rightEditorInstance.getData();
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(raw, 'text/html');
      const pretty = doc.body.innerHTML;
      this.rightEditorInstance.setData(pretty);
    } catch { }
  }

  doSave() {
    const raw = (this.rightEditorInstance && typeof this.rightEditorInstance.getData === 'function')
      ? this.rightEditorInstance.getData()
      : (this.rightData || '');

    const cleaned = this.normalizeVddHtml(raw);
    this.save.emit(cleaned);
    this.close();
  }
  private normalizeVddHtml(rawHtml: string): string {
    if (!rawHtml) return rawHtml || '';

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(rawHtml, 'text/html');

      // Remove all <del class="vdd-removed"> elements
      const dels = Array.from(doc.querySelectorAll('del.vdd-removed, .vdd-removed'));
      for (const delEl of dels) {
        if (delEl.parentNode) {
          delEl.parentNode.removeChild(delEl);
        }
      }

      // Unwrap all <ins class="vdd-added"> elements (move children out then remove the ins)
      const insList = Array.from(doc.querySelectorAll('ins.vdd-added'));
      for (const insEl of insList) {
        const parent = insEl.parentNode;
        if (!parent) {
          // no parent, just remove or skip
          continue;
        }
        // Move all children of insEl before the insEl in parent
        while (insEl.firstChild) {
          parent.insertBefore(insEl.firstChild, insEl);
        }
        // Remove the (now empty) ins element
        parent.removeChild(insEl);
      }
      this.removeClasses(doc, ['vdd-added']);
      // Return cleaned inner HTML of body
      return doc.body ? doc.body.innerHTML : doc.documentElement?.innerHTML || '';
    } catch (e) {
      // Fallback: basic regex-based removals (best-effort, not as safe)
      let out = rawHtml;
      // remove <del class="vdd-removed">...</del>
      out = out.replace(/<del\b[^>]*\bvdd-removed\b[^>]*>[\s\S]*?<\/del>/gi, '');
      // unwrap <ins class="vdd-added">...</ins> -> keep inner
      out = out.replace(/<ins\b[^>]*\bvdd-added\b[^>]*>([\s\S]*?)<\/ins>/gi, (_, inner) => inner || '');
      return out;
    }
  }
private removeClasses = (doc: Document, classPatterns: Array<string | RegExp>) => {
      const all = Array.from(doc.querySelectorAll('*')) as Element[];
      for (const el of all) {
        if (!el.classList || el.classList.length === 0) continue;
        const classes = Array.from(el.classList);
        let changed = false;
        for (const cls of classes) {
          for (const pat of classPatterns) {
            if (typeof pat === 'string') {
              if (cls === pat) {
                el.classList.remove(cls);
                changed = true;
                break;
              }
            } else { // RegExp
              if (pat.test(cls)) {
                el.classList.remove(cls);
                changed = true;
                break;
              }
            }
          }
        }
        // If no classes remain, remove the attribute
        if (el.classList.length === 0 && el.hasAttribute('class')) {
          el.removeAttribute('class');
        } else if (changed) {
          // optional: normalize whitespace in class attribute
          const normalized = Array.from(el.classList).join(' ');
          el.setAttribute('class', normalized);
        }
      }
    };

  close() {
    try {
      if (this.leftEditorInstance && typeof this.leftEditorInstance.destroy === 'function') {
        this.leftEditorInstance.destroy();
      }
    } catch { }
    try {
      if (this.rightEditorInstance && typeof this.rightEditorInstance.destroy === 'function') {
        this.rightEditorInstance.destroy();
      }
    } catch { }
    this.closed.emit();
  }

  public onChange({ editor }: ChangeEvent) {


  }
  onReady(editor: ClassicEditor): void {

    // editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {

    //     return new UploadFileAdapter( loader, this._tokenService );
    // };
  }

  startLoading(status: string = 'Loading...') {
    this.loadingStatus = status;
    this.loading = true;
    // ensure view updates immediately
    try { this.cdr.detectChanges(); } catch { }
  }

  // Update the status text while loading
  updateLoading(status: string) {
    this.loadingStatus = status;
    try { this.cdr.detectChanges(); } catch { }
  }

  // Hide loading overlay
  stopLoading() {
    this.loading = false;
    this.loadingStatus = '';
    try { this.cdr.detectChanges(); } catch { }
  }

  ngOnDestroy() {
    this.close();
  }
}